<div class='modal-content'>
  <div class='modal-body text-left no-padding' [ngClass]="{'primary-bg-color': upsellItemInfos?.length > 1}" id="modal-title">
      <ng-container *ngIf="upsellItemInfos?.length === 1">
        <fts-checkout-upsell-item *ngIf="!(breakPointService.isXSMobile$ | async)"
                                  [upsellItem]="upsellItemInfos[0].upsellItem"
                                  [title]="upsellItemInfos[0].title"
                                  (itemAddedToOrder)="onItemAddedToOrder($event)"></fts-checkout-upsell-item>
        <fts-checkout-upsell-item *ngIf="(breakPointService.isXSMobile$ | async)"
                                  [upsellItem]="upsellItemInfos[0].upsellItem"
                                  class="padded-4 flex-100 upsell-item-info-container"
                                  [title]="upsellItemInfos[0].title"
                                  [useVerticalLayout]="true"
                                  (itemAddedToOrder)="onItemAddedToOrder($event)"></fts-checkout-upsell-item>
      </ng-container>
      <ng-container *ngIf="upsellItemInfos?.length > 1">
        <div class="upsell-item-infos-container padded-2">
          <fts-checkout-upsell-item *ngFor="let upsellItemInfo of upsellItemInfos"
                                    [upsellItem]="upsellItemInfo.upsellItem"
                                    class="padded-2 upsell-item-info-container"
                                    [ngClass]="{'flex-33': upsellItemInfos.length > 2, 'flex-50': upsellItemInfos.length === 2, 'flex-80': (breakPointService.isXSMobile$ | async)}"
                                    [title]="upsellItemInfo.title"
                                    [useVerticalLayout]="true"
                                    [hideDescription]="true"
                                    (itemAddedToOrder)="onItemAddedToOrder($event)"></fts-checkout-upsell-item>
        </div>
      </ng-container>
  </div>
  <div class='modal-footer no-padding no-border'>
    <button
      ftsAuditableButton
      class="btn btn btn-link action-bg-color action-inverse-text-color font-secondary no-right-padding fw-600"
      (click)='handleNoThanks()'>
      {{'component.checkout_upsell_modal.no_continue' | translate}}&nbsp;<span aria-hidden="true">></span></button>
  </div>
</div>
